//containers
import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
// import { fetchMeasurementUnit, editMeasurementUnit, clearMeasurementUnitEdited, deleteMeasurementUnit } from '../../actions/products_actions';
import { DrayageList } from '../../components/Products/drayageList';

let drayageList = reduxForm({
  form: 'drayageList',
})(DrayageList);

function mapStateToProps(state) {
  return {
    // measurementUnitFetched: state.products.measurementUnitFetched,
    // fetchingMeasurementUnit: state.products.fetchingMeasurementUnit,
    // measurementUnitFetchError: state.products.measurementUnitFetchError,
    // editingMeasurementUnit: state.products.editingMeasurementUnit,
    // measurementUnitEdited: state.products.measurementUnitEdited,
    // measurementUnitEditError: state.products.measurementUnitEditError,
    // deletingMeasurementUnit: state.products.deletingMeasurementUnit,
    // deleteMeasurementUnitSuccess: state.products.deleteMeasurementUnitSuccess,
    // deleteMeasurementUnitError: state.products.deleteMeasurementUnitError,
  }
}

export default connect(mapStateToProps, {
//   fetchMeasurementUnit, editMeasurementUnit, clearMeasurementUnitEdited, deleteMeasurementUnit
})(drayageList)



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/drayageList.jsx